var _ = require("lodash");

function InputOption(caption) {
  if(_.keys(this).length > 0) return new InputOption(caption);
  this.type = "InputOption";
  this.caption = caption;
  this.toString = function() { return "[InputOption]"; };
}

function SumForm(subforms, caption) {
  if(_.keys(this).length > 0) return new SumForm(subforms, caption);
  this.type = "SumForm";
  this.subforms = subforms;
  this.caption  = caption;
  this.toString = function() {
    return "[SumForm <" + this.subforms.map(function(x){ return x.toString(); }).join(" ") + ">]";
  };
}

function LockedForm(form) {
  if(_.keys(this).length > 0) return new LockedForm(form);
  this.type = "LockedForm";
  this.form = form;
}

function EmptyForm1() {
  this.type = "EmptyForm";
  this.toString = function() { return "[EmptyForm]"; };
}

var EmptyForm = new EmptyForm1();

var formTypes = {
	EmptyForm: {
		isEmpty: () => true,
		isEffectivelyEmpty: () => true,
		match: () => { throw new Error('Empty form has no move'); },
	},
	InputOption: {
		isEffectivelyEmpty: () => false,
		match: (move) => move === undefined,
	},
	SumForm: {
		isEffectivelyEmpty: ({ subforms }) => _.every(subforms, isEffectivelyEmpty),
		match: ({ subforms }, { mark, value }) =>
			0 < mark && mark < subforms.length && match(subforms[mark], value),
	},
	LockedForm: {
		isEffectivelyEmpty: () => false,
		match: () => { throw new Error('LockedForm has no moves'); },
	},
	MarkedForm: {
		isEmpty: ({ value }) => isEmpty(value),
		isEffectivelyEmpty: ({ value }) => isEffectivelyEmpty(value),
		match: ({ mark, value }, move) => match(value, move),
	}
};

function getFormTypeInterface(form) {
	if (formTypes[form.type] === undefined) throw new Error(`Unknown form type ${form.type}`);
	return formTypes[form.type];
}

function match(form, move) {
	return getFormTypeInterface(form).match(form, move);
}

function isEmpty(form) {
	var int = getFormTypeInterface(form);
	return int.isEmpty && int.isEmpty(form);
}

function isEffectivelyEmpty(form) {
	return getFormTypeInterface(form).isEffectivelyEmpty(form);
}

function addFormType(type, isEmpty, isEffectivelyEmpty, match) {
	if (formTypes[type]) {
		console.error(`Form type ${type} is already defined`);
	}
	formTypes[type] = { isEmpty, isEffectivelyEmpty, match };
}

module.exports = window.Forms = {
  InputOption,
	SumForm,
	LockedForm,
	EmptyForm,
	formTypes,
	match,
	isEmpty,
	isEffectivelyEmpty,
	addFormType,
};;
